import React from "react";
import { Route } from "react-router-dom";
const LoginPage = React.lazy(() => import("pages/publicPages/login/LoginPage"));

const publicRoutes = (
  <>
    <Route path="/" element={<LoginPage />} />
  </>
);

export default publicRoutes;
